import { Component, OnInit } from '@angular/core';
import { LOGIN_PAGES } from '../login-process/enum-login-pages';
import { ActivatedRoute } from '@angular/router';

import { DialogService } from 'primeng/dynamicdialog';
import { LoginModalComponent } from 'src/app/components/login-modal/login-modal.component';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { first, Observable } from 'rxjs';
import { ConfigService } from 'src/app/services/config-service/config.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
})
export class RegisterComponent implements OnInit {
  config: any = null;

  constructor(
    private dialogService: DialogService,
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    private configService: ConfigService
  ) {
    const strConfig = localStorage.getItem('config-service');
    if (strConfig) {
      this.config = JSON.parse(strConfig);
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const token = params['token'];
      if (this.config === null) {
        this.configService._config_$.subscribe((x) => {
          this.config = x;
          this.checkToken(token);
        });
      } else {
        this.checkToken(token);
      }
    });
  }

  checkToken(token: string) {
    let params = new HttpParams();
    params = params.set('token', token);

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const submission$: Observable<any> = this.httpClient.post(
      this.config.validateSignupTokenURL,
      null,
      { headers: headers, params: params }
    );
    submission$.pipe(first()).subscribe({
      next: (response) => {
        this.openModal(LOGIN_PAGES.PASSWORD_CREATION, response.email);
      },
      error: () => {
        this.openModal(LOGIN_PAGES.LINK_EXPIRED, '');
      },
    });
  }

  openModal(step: number, email = '') {
    const ref = this.dialogService.open(LoginModalComponent, {
      data: {
        step: step,
        email: email,
      },
      width: '980px',
      closeOnEscape: false,
    });

    ref.onClose.subscribe(() => {
      history.pushState(null, '', '/');
    });
  }
}
